import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { Paginator } from "primereact/paginator";
import "./Filter.css";

const FiltersDatatableComponent = ({
  data,
  filters,
  header,
  loading,
  first,
  rows,
  totalRecords,
  onPageChange,
  onApplyFilter,
  onEditFilter,
  onDeleteFilter,
}) => {
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="actions">
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-text  mr-2"
          onClick={() => onApplyFilter(rowData)}
          tooltip="Preview Results"
          tooltipOptions={{ position: "top" }}
          style={{ color: "#D97A07" }}
        />
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-text mr-2"
          onClick={() => onEditFilter(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "top" }}
          style={{ color: "#0D2E4D" }}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-text p-button-danger"
          onClick={() => onDeleteFilter(rowData)}
          tooltip="Delete"
          tooltipOptions={{ position: "top" }}
        />
      </div>
    );
  };

  const rulesBodyTemplate = (rowData) => {
    return (
      <div>
        {rowData.rules.map((rule, index) => (
          <div
            key={index}
            style={{ fontSize: "0.875rem", marginBottom: "0.25rem" }}
          >
            <strong>{rule.field}</strong> {rule.operator}
            {!["isEmpty", "isNotEmpty"].includes(rule.operator) && (
              <>
                {" "}
                "<strong>{rule.value}</strong>"
              </>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="table-container">
      {loading ? (
        <div className="loader-container">
          <ProgressSpinner />
        </div>
      ) : (
        <>
          <DataTable
            value={data}
            paginator={false}
            header={header}
            emptyMessage="No filters found. Create your first filter to get started."
            filters={filters}
            globalFilterFields={["name", "formTitle"]}
            responsiveLayout="scroll"
            style={{ fontFamily: "poppins" }}
          >
            <Column
              field="name"
              header="Filter Name"
              sortable
              style={{ minWidth: "200px" }}
            />
            <Column
              field="formTitle"
              header="Form"
              sortable
              style={{ minWidth: "200px" }}
            />
            <Column
              header="Rules"
              body={rulesBodyTemplate}
              style={{ minWidth: "300px" }}
            />
            {/* <Column
              field="createdAt"
              header="Created"
              body={dateBodyTemplate}
              sortable
              style={{ minWidth: "180px" }}
            /> */}
            <Column
              header="Actions"
              body={actionBodyTemplate}
              style={{ minWidth: "150px", textAlign: "center" }}
            />
          </DataTable>
          <Paginator
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
          ></Paginator>
        </>
      )}
    </div>
  );
};

export default FiltersDatatableComponent;
